export default [{
    title: 'mainmenu.home',
    to: {
        name: 'index'
    },
    icon: {
        icon: 'ri-home-smile-line'
    },
}, {
    title: 'mainmenu.outpatient',
    feature: 'enable_medical',
    icon: {
        icon: 'ri-stethoscope-line'
    },
    children: [{
        title: 'mainmenu.panel-doctor-list',
        to: {
            path: '/outpatient/panel-doctor-list'
        },
        icon: {
            icon: 'ri-stethoscope-line'
        },
    }, {
        title: 'mainmenu.e-medical-card',
        to: {
            path: '/medical-card'
        },
        icon: {
            icon: 'ri-stethoscope-line'
        },
    }]
}, {
    title: 'mainmenu.wellness',
    feature: 'enable_wellness',
    to: {
        name: 'wellness'
    },
    icon: {
        icon: 'ri-hearts-line'
    },
}, {
    title: 'mainmenu.my-benefit',
    feature: 'enable_pay_and_claim',
    to: {
        path: '/my-benefit'
    },
    icon: {
        icon: 'ri-survey-line'
    },
}, {
    title: 'mainmenu.submit-claim',
    feature: 'enable_pay_and_claim_submit',
    to: {
        path: '/my-benefit/submit-claim'
    },
    icon: {
        icon: 'ri-survey-line'
    },
}, {
    title: 'mainmenu.claim-history',
    feature: 'enable_pay_and_claim_submit',
    to: {
        path: '/my-benefit/claim-history'
    },
    icon: {
        icon: 'ri-survey-line'
    },
}, {
    title: 'mainmenu.faq',
    to: {
        name: 'faq'
    },
    icon: {
        icon: 'ri-survey-line'
    },
}, {
    title: 'mainmenu.contact-us',
    to: {
        name: 'contact-us'
    },
    icon: {
        icon: 'ri-phone-line'
    },
}]